import { MAP_STYLE_BOUNDARY_LABEL_OPTIONS, MAP_STYLE_BOUNDARY_LAYER_ORDER } from "@app/projects/network-assessment/multi-map-export/utils/mapStyleOptions";
import { MultiMapExportBoundaryLabelOption, MultiMapExportBoundaryLayer } from "@app/projects/network-assessment/multi-map-export/interfaces";

/** Orders and deduplicates, since each layer appears in the canonical order once. */
const orderLayers = (layers: readonly MultiMapExportBoundaryLayer[]): MultiMapExportBoundaryLayer[] =>
  MAP_STYLE_BOUNDARY_LAYER_ORDER.filter((layer) => layers.includes(layer));

const parentOf = (layer: MultiMapExportBoundaryLayer): MultiMapExportBoundaryLayer | undefined =>
  MAP_STYLE_BOUNDARY_LABEL_OPTIONS.find((option) => option.layer === layer)?.dependsOn;

/**
 * Recurses because the dependencies chain: one pass over [zip boundary, zip labels, zip points] with the
 * boundary gone still sees zip labels present, so it would keep the points.
 */
const retainSupported = (layers: readonly MultiMapExportBoundaryLayer[]): MultiMapExportBoundaryLayer[] => {
  const supported = layers.filter((layer) => {
    const parent = parentOf(layer);

    return !parent || layers.includes(parent);
  });

  return supported.length === layers.length ? supported : retainSupported(supported);
};

export const toggleBoundaryLayer = (
  selectedLayers: readonly MultiMapExportBoundaryLayer[],
  layer: MultiMapExportBoundaryLayer,
  isSelected: boolean,
): MultiMapExportBoundaryLayer[] => {
  const toggled = isSelected
    ? [...selectedLayers, layer]
    : selectedLayers.filter((selected) => selected !== layer);

  return orderLayers(retainSupported(toggled));
};

export const isBoundaryLabelAvailable = (
  selectedLayers: readonly MultiMapExportBoundaryLayer[],
  option: MultiMapExportBoundaryLabelOption,
): boolean => selectedLayers.includes(option.dependsOn);
